import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-16 bg-background-50" id="faq">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs uppercase tracking-[0.2em] text-foreground-500 font-medium mb-3">Got Questions?</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Everything you need to know about the CSSBuy Spreadsheet and how to use it effectively
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="border border-background-200/70 rounded-lg overflow-hidden bg-background-50"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{item.question}</span>
                <i
                  className={`ri-add-line text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === idx ? 'rotate-45' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}